export const baseURL = process.env.REACT_APP_BASE_URL;
export const env = process.env.REACT_APP_ENV;
export const wssURL = process.env.REACT_APP_WSS_URL;
export const signInURL = process.env.REACT_APP_SIGN_IN_URL;
export const signUpURL = process.env.REACT_APP_SIGN_UP_URL;
export const contactEmail = process.env.REACT_APP_CONTACT_EMAIL;
export const siteURL = process.env.REACT_APP_SITE_URL;
